export default __webpack_public_path__ + "static/media/index-fund-banners-2.e27d37a1.png";